import { InMemoryCache } from "@apollo/client";
import schemaFragmentTypes from "../../__generated__/fragmentTypes.json";

export const cache = new InMemoryCache({
  possibleTypes: schemaFragmentTypes.__schema.types.reduce(
    (acc, supertype) => {
      if (supertype.possibleTypes) {
        acc[supertype.name] = supertype.possibleTypes.map(
          (subtype) => subtype.name,
        );
      }
      return acc;
    },
    {} as Record<string, string[]>,
  ),
});
